export default "//yastatic.net/s3/distribution/pythia/frontend/_/b020f3efd20a0d49b1c7e7794ddb204f.png";